import { createContext } from 'react';

const PluginContext = createContext();

export default PluginContext;
